import {
  applicationCollectFormTenants,
  FormSectionStatus,
  getResponseFormDynamicApi,
  LocalStorageKey,
  newTenants,
  ResponseFormDynamicApi,
} from "@/services/constants";
import { getLayout, getPortalApiBase } from "@/services/services";
import {
  QueryFilter,
  QueryFilterArr,
  RequestQueryBuilder,
} from "@nestjsx/crud-request";
import axios, { AxiosResponse } from "axios";
import { isArray, isDate, isNil } from "lodash";
import { generateToken } from "services/otplibServices";

interface FileUploadResponse {
  name: string;
  originalName?: string;
  extension?: string;
  size?: number;
  type?: string;
  url: string;
}

export async function getFormApplyPrivateApi(
  hostNameUrl?: string,
  recruitmentPlanId?: string,
  applicationCode?: string
) {
  let actualHostName = getPortalApiBase(hostNameUrl);

  const url = `${actualHostName}/portals/form-templates/talent-apply`;

  const response = await axios
    .get(url, {
      headers: {
        "ngrok-skip-browser-warning": "1",
        "Access-Control-Allow-Origin": "*",
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((error) => null);

  return response
    ? getResponseFormDynamicApi(false, null, response.data, "")
    : getResponseFormDynamicApi(
        true,
        "DF-AP-1-0",
        null,
        "Đã xảy ra lỗi ở server khi lấy template cho form"
      );
}

export async function getFormAdvancedInfoTemplateApi(
  hostNameUrl: string,
  recruitmentPlanId?: string,
  applicationCode?: string
): Promise<ResponseFormDynamicApi> {
  let actualHostName = getPortalApiBase(hostNameUrl);
  let res = undefined;
  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    res = await getLayout(false);
    if (!res) {
      return getResponseFormDynamicApi(
        true,
        "DF-AIF-1-1",
        null,
        "Đã xảy ra lỗi ở server khi lấy template cho form"
      );
    }
    tenant = res.tenant;
  }

  const qb = RequestQueryBuilder.create();
  if (tenant.length > 0) {
    const filterArray: (QueryFilter | QueryFilterArr)[] = [
      {
        field: "tenant",
        operator: "$eq",
        value: tenant,
      },
    ];
    qb.setFilter(filterArray);
  }

  let url = `${actualHostName}/portals/masterdata/form/talent-info?${qb.query()}`;
  if (newTenants.includes(tenant)) {
    url = `${actualHostName}/portals/recruitments/${recruitmentPlanId}/form-template/PortalTalentExtraInfo`;
  }

  if (applicationCode && applicationCollectFormTenants.includes(tenant)) {
    url = `${actualHostName}/portals/applications/${applicationCode}/form-template/PortalTalentExtraInfo`;
  }

  const response = await axios
    .get(url, {
      headers: {
        "ngrok-skip-browser-warning": "1",
        "Access-Control-Allow-Origin": "*",
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((error) => null);
  return response
    ? getResponseFormDynamicApi(false, null, response.data, "")
    : getResponseFormDynamicApi(
        true,
        "DF-AIF-1-0",
        null,
        "Đã xảy ra lỗi ở server khi lấy template cho form"
      );
}

export async function getDynamicFormTemplateApi(
  hostNameUrl: string,
  code: string,
  lang: string
) {
  let actualHostName = getPortalApiBase(hostNameUrl);
  let res = undefined;
  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    res = await getLayout(false);
    if (!res) {
      return getResponseFormDynamicApi(
        true,
        "DF-AIF-1-1",
        null,
        "Đã xảy ra lỗi ở server khi lấy template cho form"
      );
    }
    tenant = res.tenant;
  }
  // const testCode = code ?? "offer-request-form";
  console.log("url test", actualHostName);
  let testURL = `${actualHostName}/portals/dynamic-forms/by-code/${code}`;
  const response = await axios
    .get(testURL, {
      headers: {
        "x-language": lang,
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((_error) => null);
  console.log("response", response);
  return response?.data;
}

export async function getTalentInfoApi(
  hostNameUrl: string | undefined,
  code: string
): Promise<ResponseFormDynamicApi> {
  let actualHostName = getPortalApiBase(hostNameUrl);

  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    const res = await getLayout(false);
    if (!res) {
      return getResponseFormDynamicApi(
        true,
        "DF-AIF-1-1",
        null,
        "Đã xảy ra lỗi ở server khi lấy template cho form"
      );
    }
    tenant = res.tenant;
  }

  let url = `${actualHostName}/portals/applications/${code}/advanced-info`;
  if (newTenants.includes(tenant)) {
    url = `${actualHostName}/portals/applications/${code}/extra-info`;
  }

  const otpToken = typeof window !== "undefined" ? sessionStorage.getItem("otp_session_token") : null;
  const response: AxiosResponse<{
    application: any;
    advancedInfo: any;
  }> | null = await axios
    .get(url, {
      headers: {
        "ngrok-skip-browser-warning": "1",
        "Access-Control-Allow-Origin": "*",
        "x-dynamic-token": generateToken(),
        ...(otpToken ? { "x-otp-session": otpToken } : {}),
      },
    })
    .catch((error) => null);
  return response
    ? getResponseFormDynamicApi(false, null, response.data, "")
    : getResponseFormDynamicApi(
        true,
        "DF-AIF-2",
        null,
        "Đã xảy ra lỗi ở server khi lấy thông tin ứng viên"
      );
}

export async function postFormTalentAdvancedInfo(
  formDynamicData: any,
  hostNameUrl: string,
  talentApplicationId: string
) {
  let actualHostName = getPortalApiBase(hostNameUrl);

  let errorCode = null;
  const fileUploadPromise: Promise<FileUploadResponse | null>[] = [];
  const copyFormDynamicData = { ...formDynamicData };

  const certificateKey = formDynamicData.certificate
    ? "certificate"
    : "certificates";
  formDynamicData[certificateKey].forEach(
    (certificateSingle: any, index: number) => {
      if (certificateSingle.file instanceof File) {
        fileUploadPromise.push(
          uploadAnyFile(certificateSingle.file, hostNameUrl).then((fileRes) => {
            copyFormDynamicData[certificateKey][index].file = fileRes
              ? fileRes.url
              : "Lỗi xảy ra khi tải hình ảnh/tải danh sách";
            return fileRes;
          })
        );
      }
    }
  );

  if (formDynamicData["identityFiles"]) {
    formDynamicData["identityFiles"].forEach(
      (identityFile: any, index: number) => {
        if (identityFile instanceof File)
          fileUploadPromise.push(
            uploadAnyFile(identityFile, hostNameUrl).then((fileRes) => {
              copyFormDynamicData["identityFiles"][index] = fileRes
                ? fileRes.url
                : "Lỗi xảy ra khi tải hình ảnh/tải danh sách";
              return fileRes;
            })
          );
      }
    );
  }

  const url = `${actualHostName}/portals/applications/${talentApplicationId}/talent-advanced-info`;
  const axiosResponseData = await Promise.all(fileUploadPromise)
    .then((res) => {
      return axios
        .post(url, copyFormDynamicData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "x-dynamic-token": generateToken(),
          },
        })
        .then((response) => {
          if (response.data && response.data._id) return response.data;
          else {
            errorCode = "DF-AIF-3-1";
            return null;
          }
        })
        .catch((error) => {
          errorCode = "DF-AIF-3-2";
          return null;
        });
    })
    .catch((error) => {
      errorCode = "DF-AF-3-3";
      return null;
    });

  return axiosResponseData
    ? getResponseFormDynamicApi(
        false,
        null,
        axiosResponseData,
        "Cảm ơn bạn đã nộp đơn bổ sung thông tin"
      )
    : getResponseFormDynamicApi(
        true,
        errorCode,
        null,
        "Đã xảy ra lỗi ở server"
      );
}

export async function getLocationData(
  masterDataToUpdateString: string,
  locationCode: number,
  hostNameUrl: string
): Promise<ResponseFormDynamicApi> {
  let actualHostName = getPortalApiBase(hostNameUrl);

  let resLayout = undefined;
  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    resLayout = await getLayout(false);
    if (!resLayout) {
      return getResponseFormDynamicApi(
        true,
        "DF-AIF-4-2",
        null,
        "Đã xảy ra lỗi ở server khi lấy thông tin của vị trí"
      );
    }
    tenant = resLayout.tenant;
  }

  const qb = RequestQueryBuilder.create();

  if (tenant.length > 0) {
    qb.setFilter({
      field: "tenant",
      operator: "$eq",
      value: tenant,
    });
  }

  const url = `${actualHostName}/portals/masterdata/${masterDataToUpdateString}/data?ref=${locationCode}&${qb.query()}`;

  const response = await axios
    .get(url, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((error) => null);
  return response
    ? getResponseFormDynamicApi(false, null, response.data, "")
    : getResponseFormDynamicApi(
        true,
        "DF-AIF-4-1",
        null,
        "Đã xảy ra lỗi ở server khi lấy thông tin của vị trí"
      );
}

export async function getFormQuickApplyTemplateApi(
  hostNameUrl?: string,
  recruitmentPlanId?: string,
  applicationCode?: string,
  isCampaign?: boolean
) {
  let actualHostName = getPortalApiBase(hostNameUrl);

  const formName = process.env.NEXT_PUBLIC_API_URL
    ? actualHostName.slice(8, -4)
    : hostNameUrl;

  let resLayout = undefined;
  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    resLayout = await getLayout(false);
    if (!resLayout) {
      return getResponseFormDynamicApi(
        true,
        "DF-QFA-5-2",
        null,
        "Đã xảy ra lỗi khi lấy template form apply nhanh"
      );
    }
    tenant = resLayout.tenant;
  }
  const qb = RequestQueryBuilder.create();
  if (tenant.length > 0) {
    const filterArray: (QueryFilter | QueryFilterArr)[] = [
      {
        field: "tenant",
        operator: "$eq",
        value: tenant,
      },
    ];
    qb.setFilter(filterArray);
  }

  let url = `${actualHostName}/portals/masterdata/form/form-${formName}?${qb.query()}`;

  if (newTenants.includes(tenant)) {
    if (isCampaign) {
      url = `${actualHostName}/portals/campaigns/${recruitmentPlanId}/form-template/portal-talent-apply-recruitment`;
    } else {
      url = `${actualHostName}/portals/recruitments/${recruitmentPlanId}/form-template/PortalTalentApplyRecruitment`;
    }
  }
  console.log("url", url);

  const response = await axios
    .get(url, {
      headers: {
        "ngrok-skip-browser-warning": "1",
        "Access-Control-Allow-Origin": "*",
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((error) => null);

  console.log("response", response);
  return response
    ? getResponseFormDynamicApi(false, null, response.data, "")
    : getResponseFormDynamicApi(
        true,
        "DF-QFA-5-1",
        null,
        "Đã xảy ra lỗi khi lấy template form apply nhanh"
      );
}

export async function postFormQuickApply(
  formDynamicData: any,
  hostNameUrl: string
) {
  const postFormData: any = {
    basics: {
      location: {},
      profiles: [],
      label: "",
    },
    meta: {
      source: "portal",
    },
    tags: ["public"],
  };
  const fileResDataArray: FileUploadResponse[] = [];
  const fileUploadPromises: Promise<FileUploadResponse | null>[] = [];
  const errorServerMessage = "Đã xảy ra lỗi khi nộp đơn ứng tuyển nhanh";

  const updateFormData = (
    formDynamicDataValue: any,
    key: string,
    formDynamicDataObjectKey: string | null
  ) => {
    if (formDynamicDataValue instanceof File) {
      const uploadFileFunc = async () =>
        await uploadAnyFile(formDynamicDataValue, hostNameUrl);
      fileUploadPromises.push(
        uploadFileFunc()
          .then((fileResData) => {
            if (fileResData) {
              fileResDataArray.push({ ...fileResData });
              return fileResData;
            }
            return null;
          })
          .catch((error) => null)
      );
    } else {
      if (formDynamicDataObjectKey)
        postFormData[key][formDynamicDataObjectKey] = formDynamicDataValue;
      else {
        postFormData[key] = formDynamicDataValue;
      }
    }
  };

  Object.keys(formDynamicData).forEach((key) => {
    if (typeof formDynamicData[key] === "object") {
      if (!Object.keys(postFormData).includes(key)) postFormData[key] = {};
      Object.keys(formDynamicData[key]).forEach((formDynamicDataObjectKey) => {
        const formDynamicDataValue =
          formDynamicData[key][formDynamicDataObjectKey];
        updateFormData(formDynamicDataValue, key, formDynamicDataObjectKey);
      });
    } else {
      const formDynamicDataValue = formDynamicData[key];
      if (key === "email") {
        updateFormData(formDynamicDataValue, "basics", key);
      } else {
        updateFormData(formDynamicDataValue, key, null);
      }
    }
  });
  return Promise.all(fileUploadPromises)
    .then((res) => {
      let errorPromiseAll = false;
      res.forEach((eachRes) => {
        if (!eachRes) errorPromiseAll = true;
      });

      if (errorPromiseAll) {
        return getResponseFormDynamicApi(
          true,
          "DF-QAF-1",
          null,
          errorServerMessage
        );
      }

      postFormData["files"] = [...fileResDataArray];

      let actualHostName =
        getPortalApiBase(hostNameUrl);
      const url = `${actualHostName}/portals/talents`;
      const postForm = async () =>
        await axios.post(url, postFormData, {
          headers: {
            "x-dynamic-token": generateToken(),
          },
        });
      return postForm()
        .then((res) => {
          if (res.data) {
            const formApplyResult = res.data;
            if (formApplyResult.code) {
              return getResponseFormDynamicApi(
                false,
                null,
                formApplyResult.code,
                "Cảm ơn bạn đã nộp đơn ứng tuyển nhanh"
              );
            }
          }
          return getResponseFormDynamicApi(
            true,
            "DF-QAF-2",
            null,
            errorServerMessage
          );
        })
        .catch((error) =>
          getResponseFormDynamicApi(true, "DF-QAF-3", null, errorServerMessage)
        );
    })
    .catch((error) =>
      getResponseFormDynamicApi(true, "DF-QAF-4", null, errorServerMessage)
    );
}

type NewFile =
  | File
  | {
      name: string;
      type: string;
      url: string;
    };

function resolveFileManagerFileId(urlOrFilename: string) {
  if (!urlOrFilename) return "";
  if (/^(blob:|data:)/i.test(urlOrFilename)) return urlOrFilename;

  const withoutHash = urlOrFilename.split("#")[0];
  const withoutQuery = withoutHash.split("?")[0];
  const path = (() => {
    try {
      return new URL(withoutQuery).pathname;
    } catch {
      return withoutQuery;
    }
  })();

  const segments = path.split("/").filter(Boolean);
  return segments[segments.length - 1] || "";
}

export async function uploadAnyFile(
  file: NewFile,
  hostNameUrl: string
): Promise<FileUploadResponse | null> {
  if (!file) return null;
  function isRealFile(f: any): f is File {
    return typeof File !== "undefined" && f instanceof File;
  }
  let actualHostName = getPortalApiBase(hostNameUrl);

  // If not a File type ( in {name, type, url} format)
  if (!isRealFile(file)) {
    return {
      name: file.name,
      type: file.type,
      url: resolveFileManagerFileId(file.url || file.name),
    };
  }

  let bodyFormData = new FormData();
  bodyFormData.append("file", file);

  const useFileUrlConfig = localStorage.getItem(
    LocalStorageKey.USE_FILE_URL_CONFIG
  );
  let fileUrl: string | null = null;
  if (useFileUrlConfig) {
    fileUrl = localStorage.getItem(LocalStorageKey.FILE_URL);
    if (!fileUrl) {
      const resLayout = await getLayout(false);
      if (!resLayout) {
        return null;
      }
      fileUrl = resLayout.layout?.config?.fileUrl || null;
    }
  }

  const url = fileUrl || `${actualHostName}/portals/file-manager`;

  const response = await axios
    .post(url, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*",
        "x-dynamic-token": generateToken(),
      },
    })
    .catch((error) => null);

  if (response) {
    let dataResponse = response.data;
    if (Array.isArray(response.data)) {
      dataResponse = response.data[0];
    }
    if (!dataResponse) {
      return null;
    }
    const fileResponse: {
      name: string;
      originalName: string;
      extension: string;
      size: number;
      url: string;
    } = dataResponse;
    return {
      name: fileResponse.name,
      originalName: fileResponse.originalName,
      extension: fileResponse.extension,
      size: fileResponse.size,
      url: resolveFileManagerFileId(fileResponse.url || fileResponse.name),
    };
  }
  return null;
}

export async function checkVerificationCode(
  applicationCode: string,
  verificationCode: string,
  hostNameUrl: string
): Promise<ResponseFormDynamicApi> {
  const actualHostName = getPortalApiBase(hostNameUrl);

  const url = `${actualHostName}/portals/applications/${applicationCode}/code-verify`;

  let errorCode = "code-verify-1-0";
  let errorMessage = "Đã xảy ra lỗi trong quá trình xác thực mã";
  const response = await axios
    .post(
      url,
      { verificationCode },
      {
        headers: {
          "ngrok-skip-browser-warning": "1",
          "x-dynamic-token": generateToken(),
        },
      }
    )
    .catch((err) => {
      if (err?.response?.status === 401 || err?.response?.status === 400) {
        errorCode = err?.response?.data?.code || "code-verify-1-1";
        errorMessage =
          err?.response?.data?.message ||
          "Mã OTP không đúng. Vui lòng kiểm tra và thử lại.";
      }
      return null;
    });

  if (!response) {
    return getResponseFormDynamicApi(true, errorCode, null, errorMessage);
  }

  // API returns 4xx for invalid OTP (axios throws → caught above as null).
  // If we reach here, status is 2xx → success.
  return getResponseFormDynamicApi(false, null, response.data, "");
}

function cleanFormValues(formValues: any) {
  if (isNil(formValues)) {
    return null;
  }
  if (isDate(formValues)) {
    return formValues;
  }
  if (isArray(formValues)) {
    const res = formValues
      .map((item) => {
        return cleanFormValues(item);
      })
      .filter((item) => !isNil(item));
    return res;
  }
  if (typeof formValues === "object") {
    const cleanedObject: any = {};
    Object.keys(formValues).forEach((key) => {
      const item = cleanFormValues(formValues[key]);
      if (!isNil(item)) {
        cleanedObject[key] = item;
      }
    });
    if (Object.keys(cleanedObject).length === 0) {
      return null;
    }
    if (
      Object.keys(cleanedObject).every(
        (key) => isArray(cleanedObject[key]) && cleanedObject[key].length === 0
      )
    ) {
      return null;
    }
    return cleanedObject;
  }
  return formValues;
}

export async function postDynamicFormRefactor(
  rawFormValues: any,
  hostNameUrl: string,
  formType: "private" | "apply" | "extra-info",
  isCampaign: boolean,
  talentApplicationId = "",
  meta: any = {},
  fields: any[] = [],
  externalLink: string
) {
  let actualHostName = getPortalApiBase(hostNameUrl);
  const formValues = cleanFormValues(rawFormValues);
  let url: string;
  let tenant: string | null = localStorage.getItem(LocalStorageKey.TENANT);
  if (!tenant) {
    const resLayout = await getLayout(false);
    if (!resLayout) {
      return getResponseFormDynamicApi(
        true,
        "DF-APPLY-2",
        null,
        "Đã xảy ra lỗi khi lấy layout để nộp form"
      );
    }
    tenant = resLayout.tenant;
  }
  let postFormData: any = {};
  let errorMessage = "";
  let successMessage = "";

  switch (formType) {
    case "apply":
      if (!newTenants.includes(tenant)) {
        url = `${actualHostName}/portals/talents`;
        const baseFormData: any = {
          meta: {
            source: "portal",
          },
          website: {
            tenant: tenant,
          },
          tags: ["public"],
        };
        postFormData = Object.assign({ ...formValues }, baseFormData);

        const basicFormData = {
          location: {},
          profiles: [],
          label: "",
        };
        postFormData.basics = Object.assign(
          { ...postFormData.basics },
          basicFormData
        );
      } else {
        url = isCampaign
          ? `${actualHostName}/portals/talents/create-for-campaign`
          : `${actualHostName}/portals/talents/create`;
        postFormData = {
          body: {
            recruitmentPlan: formValues.recruitmentPlan,

            data: [],
          },
          website: {
            tenant: tenant,
          },
        };
        Object.keys(formValues).forEach((formValueKey) => {
          if (
            formValueKey !== "recruitmentPlan" &&
            Object.keys(formValues[formValueKey]).length > 0
          ) {
            postFormData.body.data.push({
              sectionCode: formValueKey,
              data: formValues[formValueKey],
            });
          }
        });

        // --- Miscelleneous section code ---
        postFormData.body.data.push({
          sectionCode: "misc",
          data: {},
        });

        // - external link
        if (!isNil(externalLink)) {
          postFormData.body.data[
            postFormData.body.data.length - 1
          ].data.externalLink = externalLink;
        }

        console.log("postFormData", postFormData);

        successMessage = "Cảm ơn bạn đã nộp đơn ứng tuyển nhanh";
        errorMessage = "Đã xảy ra lỗi khi nộp đơn ứng tuyển nhanh";
      }
      break;
    case "extra-info":
      if (!newTenants.includes(tenant)) {
        url = `${actualHostName}/portals/applications/${talentApplicationId}/talent-advanced-info`;
        postFormData = { ...formValues };
      } else {
        url = `${actualHostName}/portals/applications/${talentApplicationId}/talent-extra-info`;
        postFormData = [];
        // Object.keys(formValues).forEach(formValueKey => {
        //     if (formValueKey !== "recruitmentPlan" && Object.keys(formValues[formValueKey]).length > 0) {
        //         postFormData.push({
        //             sectionCode: formValueKey,
        //             data: formValues[formValueKey]
        //         })
        //     }
        // })
        if (fields.length > 0) {
          const filteredField = fields.filter(
            (field) =>
              !field.sectionStatus ||
              field.sectionStatus === FormSectionStatus.PENDING ||
              field.sectionStatus === FormSectionStatus.REJECTED
          );
          filteredField.forEach((field) => {
            if (field.name) {
              if (field.name === "basics") {
                postFormData.push({
                  sectionCode: "basics",
                  data: cleanFormValues({
                    ...formValues[field.name],
                    meta: { ...meta },
                  }),
                });
              } else {
                postFormData.push({
                  sectionCode: field.name,
                  data: formValues[field.name],
                });
              }
            }
          });
        }
      }
      successMessage = "Cảm ơn bạn đã nộp đơn bổ sung thông tin";
      errorMessage = "Đã xảy ra lỗi khi nộp đơn bổ sung";
      break;

    case "private":
      url = isCampaign
        ? `${actualHostName}/portals/talents/create-for-campaign`
        : `${actualHostName}/portals/talents/create`;
      postFormData = {
        body: {
          data: [],
        },
        website: {
          tenant: tenant,
        },
      };
      if (fields.length > 0) {
        fields.forEach((field) => {
          if (field.name) {
            postFormData.body.data.push({
              sectionCode: field.name,
              data: formValues[field.name],
            });
          }
        });
      }

      successMessage = "Cảm ơn bạn đã nộp ứng tuyển";
      errorMessage = "Đã xảy ra lỗi khi nộp ứng tuyển";
      break;
  }

  const otpToken = typeof window !== "undefined" ? sessionStorage.getItem("otp_session_token") : null;
  const postForm = async () =>
    await axios.post(url, postFormData, {
      headers: {
        "x-dynamic-token": generateToken(),
        ...(otpToken ? { "x-otp-session": otpToken } : {}),
      },
    });
  return postForm()
    .then((res) => {
      if (res.data) {
        const formResult = res.data;
        let returnData;
        switch (formType) {
          case "apply":
            if (isCampaign && formResult && Array.isArray(formResult)) {
              returnData =
                formResult.length > 0
                  ? formResult.map((item: any) => {
                      return item?.code;
                    })
                  : null;
            } else {
              returnData = formResult.code;
            }
            break;

          case "extra-info":
            returnData = formResult.code;
            break;
        }

        return getResponseFormDynamicApi(
          false,
          null,
          returnData,
          successMessage
        );
      }
      return getResponseFormDynamicApi(true, "DF-APPLY-1", null, errorMessage);
    })
    .catch((error) =>
      getResponseFormDynamicApi(true, "DF-APPLY-2", null, errorMessage)
    );
}
